// Pure layout helpers for the in-call stage (mobile/desktop, design/05 §3.5). Orientation
// drives the two-camera split: portrait stacks the panels 50/50 vertically, landscape
// places them 50/50 horizontally. When a remote screen-share pane is present the cameras
// move to a narrow column beside it. Side-effect-free so it is unit-testable; the DOM
// orientation/resize wiring lives in CallScreen.
export type Orientation = "portrait" | "landscape";

export function deriveOrientation(width: number, height: number): Orientation {
  return height > width ? "portrait" : "landscape";
}

/** Two-camera split: portrait -> column (vertical 50/50), landscape -> row (horizontal 50/50). */
export function twoCameraDirection(orientation: Orientation): "row" | "column" {
  return orientation === "portrait" ? "column" : "row";
}

/** Camera-container direction; with a screen-share pane the cameras stack in a side column. */
export function cameraStageDirection(orientation: Orientation, screenPaneVisible: boolean): "row" | "column" {
  return screenPaneVisible ? "column" : twoCameraDirection(orientation);
}
